import { Page } from "~/components/shell/page";
import { Skeleton } from "~/components/ui/skeleton";

export function DefaultPending() {
  return (
    <Page aria-busy="true" aria-label="Pagina wordt geladen">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-[34px] w-56" />
        <Skeleton className="h-4 w-80 max-w-full" />
      </div>
      <Skeleton className="h-[180px]" />
      <Skeleton className="h-64" />
    </Page>
  );
}
